import { isEmpty, isEqual, isNil } from 'lodash';
import { API } from '@shared/types/api';
import { EditableField, Field } from './Field';

export class CombinedTagsField implements EditableField {
  readonly componentIds: string[];
  readonly tags: Map<string, string[]>;
  readonly fieldType = 'CombinedTagsField';

  constructor(componentIds: string[], entity: API.WorkflowEntity) {
    this.componentIds = componentIds;
    const tags = new Map();
    componentIds?.forEach(componentId => {
      const value = entity.fields?.[componentId];
      if (!isNil(value)) {
        tags.set(componentId, value);
      }
    });
    this.tags = tags;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof CombinedTagsField && isEqual(this.tags, field.tags);
  }

  toFieldJson() {
    return this.tags;
  }

  get isEmpty() {
    return isEmpty(this.tags);
  }
}
